/* Raghu  26/10/2022   3075154998   Inputfields Alignments and Enhancements */
import React, {useContext} from 'react';
import SearchMediaTypeContainer from './SearchMediaTypeContainer';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

function SearchMediaType({
  setTabValue,
  setCode,
  handleClose,
  setSelectedMediaTypeName,
  mediaName,
  setMediaName,
  setIsCopyData,
  disableCopy,
  setUsageState,
  setDisableCopy,
  usageState,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <div className={handleClose ? `${classes.dialoguecardStyles}` : `mb-0`}>
        <SearchMediaTypeContainer
          setTabValue={setTabValue}
          mediaName={mediaName}
          setMediaName={setMediaName}
          setCode={setCode}
          handleClose={handleClose}
          setSelectedMediaTypeName={setSelectedMediaTypeName}
          setIsCopyData={setIsCopyData}
          disableCopy={disableCopy}
          setDisableCopy={setDisableCopy}
          setUsageState={setUsageState}
          usageState={usageState}
        />
      </div>
    </>
  );
}

export default SearchMediaType;
